import { render, staticRenderFns } from "./GradeScaleTypeSlidebar.vue?vue&type=template&id=8801d656"
import script from "./GradeScaleTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./GradeScaleTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports